import { DOCUMENT } from '@angular/common';
import { AfterContentChecked, Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { GenericModalComponent } from './generic-modal/generic-modal.component';
import DadosCertificadoModel from './model/dados-certificado.model';
import { CertificadoService } from './services/certificado.service';
import { ModalAjudaAtivacaoKriptonitaComponent } from './modal-ajuda-ativacao-kriptonita/modal-ajuda-ativacao-kriptonita.component';
import { API_DOWNLOAD_KRYPTONITA, API_NODE_CERT_SITUACAO } from './app.api';
import { MessageService } from 'src/app/services/message.service';
import { Router } from '@angular/router';
import { GlobalCripto } from './global/global-constants'
import { ModalCryptoComponent } from './modal-Crypto/modal-crypto.component';
declare const xabo: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit, AfterContentChecked {

  title = 'cad-maquina';

  public servicos;

  public certificadoValido: any;
  public certificadoBloqueado: any;
  public semServico: any;
  public semServicoNode: boolean;
  public certificado;
  public dadosCertificado: DadosCertificadoModel;
  private sign: any;
 
  private messageError = '';
  private titulo = '';
  private action;
  private sim = 'Sim';
  private nao = 'Não';
  private site = '';
  perfil;
  userChecked = undefined;
  ACESSO_BLOQUEADO = 1;
  public isPerfilValido: boolean = true;
  public situacaoCertificado: boolean = true;

  constructor(private certificadoService: CertificadoService,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    private messageService: MessageService,
    private router: Router) {
  }

  ngOnInit() {

    this.autenticacoesCertificado();
  }

  openDialog(mensagem: string, action: string, titulo: string, labelconfirmar: string, labelcancelar: string, help: boolean): string {
    this.dialog.open(GenericModalComponent, { data: { mensagem, action, titulo, labelconfirmar, labelcancelar, help } });
    return mensagem;
  }


  openDialogHelp(titulo: string) {
    this.dialog.open(ModalAjudaAtivacaoKriptonitaComponent, { data: { titulo } });
  }
  ngAfterContentChecked() {
    setTimeout(() => this.verificaAmbienteUsuario(), 2000);
  }

  private verificaAmbienteUsuario() {
    if (!this.userChecked) {
    //  this.verificaNavegadorUsuario();
      this.verificaAPICriptoCNS();
    }
  }

  verificaNavegadorUsuario() {
    this.action = 'https://www.google.com/intl/pt-BR/chrome/';
    this.titulo = '';
   
   if (navigator.userAgent.indexOf('Edg') > -1) {
      console.log('Internet Explorer ou Edge');   
      this.site = 'E'; 
     } else if (navigator.userAgent.indexOf('Chrome') > -1) {     
      console.log('Google Chrome');
      this.site = 'C'; 
  }else {
    this.openDialog('O site só da suporte para o navegador Chrome e Edge. Favor utilizar o mesmo.', this.action, this.titulo, this.sim, this.nao, false);
   }

  }
   
  async autenticacoesCertificado() {

    if (await this.certificadoService.certificadoPermitido(null)) {
      this.certificado = this.certificadoService.obterDadosCertificadoServlet();
      const isCertificadoValido = await this.certificadoService.isCertificadoValido(this.certificado.codigoSerial, null)
      if (isCertificadoValido) {
        this.certificadoValido = true;
        //this.dadosCertificado = await this.certificadoService.listarDadosCertificado(this.certificado.codigoSerial);
        const nomeAutCert = this.getNomeEntidadeCert(this.certificado);
        this.dadosCertificado =  await this.certificadoService.dadosCertificado(this.certificado.codigoSerial, nomeAutCert, null);          
        if (this.isPerfilAdmAut(this.dadosCertificado.nu_perfil) || this.isPerfilGestor(this.dadosCertificado.nu_perfil)) {
          this.isPerfilValido = false;
          this.messageService.changeErrorMessage(0, 'Perfil administrador ou gestor não permite acessar manter máquina');
          this.router.navigate(['/acesso-negado-generico']);
        }
        this.dadosCertificado.de_perfil = await this.certificadoService.obterNomePerfil(this.dadosCertificado.nu_perfil);
        this.situacaoCertificado = await this.certificadoService.isCertificadoSituacao(this.certificado.codigoSerial, this.dadosCertificado.no_autoridade_certificadora, null);
      }
      else {
        if (isCertificadoValido === false) {
          this.certificadoValido = false;
        } else {
          this.semServicoNode = false;
          this.certificadoValido = null;
        }
      }

      if (this.certificadoValido) {
        if ((await this.certificadoService.isCertificadoBloqueado(this.retornarInscricaoFormatada(), null)) ||
          (await (this.validaBloqueioCPF()))) {
          this.certificadoBloqueado = false;
        }
        else this.certificadoBloqueado = true;
      }

    } else { this.semServico = false; }
  }

  async autenticacoesCertificado_() {
    if (await this.certificadoService.certificadoPermitido(null)) {
      this.certificado = this.certificadoService.obterDadosCertificadoServlet();
      if (!(await this.certificadoService.isCertificadoBloqueado(this.retornarInscricaoFormatada(), null)) && (! await (this.validaBloqueioCPF()))) {
        if (await this.certificadoService.isCertificadoValido(this.certificado.codigoSerial, null)) {
          this.certificadoValido = true;
          //this.dadosCertificado = await this.certificadoService.listarDadosCertificado(this.certificado.codigoSerial);
          const nomeAutCert = this.getNomeEntidadeCert(this.certificado);
          this.dadosCertificado =  await this.certificadoService.dadosCertificado(this.certificado.codigoSerial, nomeAutCert, null);
          if (this.isPerfilAdmAut(this.dadosCertificado.nu_perfil) || this.isPerfilGestor(this.dadosCertificado.nu_perfil)) {
            this.isPerfilValido = false;
            this.messageService.changeErrorMessage(0, 'Perfil administrador ou gestor não permite acessar manter máquina');
            this.router.navigate(['/acesso-negado-generico']);
          }
          this.dadosCertificado.de_perfil = await this.certificadoService.obterNomePerfil(this.dadosCertificado.nu_perfil);
          this.situacaoCertificado = await this.certificadoService.isCertificadoSituacao(this.certificado.codigoSerial, this.dadosCertificado.no_autoridade_certificadora, null);


        } else { this.certificadoValido = false; }
      } else { this.certificadoBloqueado = false; }
    } else { this.semServico = false; }
  }


  private retornarInscricaoFormatada(): string {
    if (this.certificado.tpInscricao === "2")
      return this.certificado.inscricao;
    else
      return this.certificado.tpInscricao + this.certificado.inscricao.padStart(14, '0');
  }

  private retornaInscricaoCPF(): string {

    return "3" + this.certificado.cpfResponsavel.padStart(14, '0');
  }

  private async validaBloqueioCPF() {
    if (this.certificado.tpInscricao === "1" || this.certificado.tpInscricao === "2") {
      return await this.certificadoService.isCertificadoBloqueado(this.retornaInscricaoCPF(), null)
    }
    return false;
  }

  isPerfilAdmAut(numPerfil: number): boolean {
    const PERFIL_ADM: number = 13
    const PERFIL_AUT: number = 14
    return undefined !== numPerfil && (PERFIL_ADM === numPerfil || PERFIL_AUT === numPerfil);
  }

  isPerfilGestor(numPerfil: number): boolean {
    const PERFIL_GESTOR: number = 101
    return undefined !== numPerfil && (PERFIL_GESTOR === numPerfil );
  }

 public async verificaAPICriptoCNS() {
  this.action = API_DOWNLOAD_KRYPTONITA;
  this.sign = await xabo.queryInterface({ compatibilityMode: true }).then((api) => {  
       console.log('API ATIVA: ' + api.signet);   
       GlobalCripto.apiAtiva = api.signet;
       GlobalCripto.clientAPI = api;
       })      
   .catch((reason) => {
     this.messageError = reason.statusText;  
     GlobalCripto.apiAtiva = 'erro';
     console.log('Erro na tentativa de carregar a CriptoCns. ');
     console.log('Motivo:' + reason.reason ) ;  
     console.log('Código: '+ reason.result) ;
     console.log("Mensagem: " +  this.messageError);    
   })  
   .finally(() => {
     this.userChecked = true;
    if (GlobalCripto.apiAtiva === 'erro' || GlobalCripto.apiAtiva === undefined){    
      GlobalCripto.clientAPI = null;  
       this.dialog.open(ModalCryptoComponent, { data: { action: this.action}, width: '60%'});
     }
   })
   ;
    return (GlobalCripto.clientAPI) ? true : false;    
    }

    private getNomeEntidadeCert(certificado): string {      
      const nomeEntidadeCert = certificado.issuer.name.split(',')[0].split('=')[1];          
      return nomeEntidadeCert;
    }

}
